export const GET_ALL_POLLS_AND_SURVEYS = "GET_ALL_POLLS_AND_SURVEYS";
export const RESET_DATA = "RESET_DATA";

// LOADING ACTION TYPES
export const START_LOADING_POLLS_AND_SURVEYS = "START_LOADING_POLLS_AND_SURVEYS";
export const STOP_LOADING_POLLS_AND_SURVEYS = "STOP_LOADING_POLLS_AND_SURVEYS";
export const ERROR_LOADING_POLLS_AND_SURVEYS = "ERROR_LOADING_POLLS_AND_SURVEYS";